import styles from './InlineLoader.module.less'

export const InlineLoader: React.FC = () => {
    return <span className={styles['inline-loader']}></span>
}
